<script setup lang="ts">
defineProps<{
    className?: string;
}>();
</script>

<template>
    <div class="inline-block bg-[#FBDBCA] px-3 py-1 font-open text-sm leading-none text-[#667F7F] xl:text-base" :class="className">
        <slot />
    </div>
</template>

<style scoped></style>
